import styled from 'styled-components';
import PageWrapper from './PageWrapper';
import { stripedBackgroundStyles } from '../styles/constants';

const StripedBackgroundPageWrapper = styled(PageWrapper)`
  ${stripedBackgroundStyles}
`;

export default StripedBackgroundPageWrapper;
